// @flow
import PaymentTokensGenerator from './PaymentTokensGenerator'
export default PaymentTokensGenerator
